export default __webpack_public_path__ + "static/media/error-404.91eee1b7.png";